<template>
<div class="menu pt-1" v-show="!isCheckData()">
    <AlertMessageComponent v-if="importMode || !modalMode" class="mx-1" id="alert-message"/>
    <div
      class="header d-flex mb-2 align-items-center flex-wrap"
      v-if="getPageTitleRoute()['subTitle'] || getPageTitleRoute()['title']"
    >
      <span class="titleMaster">{{ getPageTitleRoute()['title'] }}</span>
      <span class="titleHeader">
        {{ getPageTitleRoute()['subTitle'] }}
      </span>
    </div>
    <div class="d-flex text-dark tabsMenu">
      <ul
        class="nav nav-pills"
        v-for="(menu, index) in getSubMenusRoute()"
        :key="index"
      >
        <li class="nav-item" v-if="mstMenu[menu.name]">
          <router-link
            v-bind:to="{ name: menu.name }"
            class="nav-link itemMenu"
            :class="[{ 'active': $route.name === menu.name }, 'nav-link', 'itemMenu']"
          >
            {{ menu.meta.titleMenu }}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="header-line mt-2" v-show="this.getSubMenusRoute().length !== 0">
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppConstants from '../../constants/app.constants'
import AlertMessageComponent from '../custom-components/AlertMessageComponent.vue'
export default {
  components: {
    AlertMessageComponent
  },
  data() {
    return {
      mstMenu: AppConstants.MST_MENU
    }
  },
  created() {
    this.$_fetch_setting()
  },
  computed: {
    ...mapState('subMenus', ['_pageTitle', '_subMenus']),
    modalMode() {
      return this.$store.getters.getModalMode
    },
    importMode() {
      return this.$store.getters.getImportMode
    }
  },
  methods: {
    ...mapGetters('subMenus', ['getPageTitleRoute', 'getSubMenusRoute']),
    ...mapGetters('setting', ['getSetting']),
    /**
     * メニューデータ取得
     */
    $_fetch_setting() {
      const results = this.getSetting()
      if (!results || !results.data || !results.data.mstMenu) {
        return
      }

      const resultMstMenu = results.data.mstMenu

      for (let i = 0; i < resultMstMenu.length; i++) {
        this.mstMenu[resultMstMenu[i].menuNo] = resultMstMenu[i].visible === 1
      }
    },
    isCheckData() {
      if (Object.keys(this.getPageTitleRoute()).length === 0 && this.getSubMenusRoute().length === 0) {
        return true
      }
      return false
    }
  }

}
</script>

<style lang="scss" scoped>
div.header {
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(12);
  padding-left: 16px;
  margin-bottom: 16px;
  flex-wrap: nowrap !important;
  .titleHeader {
    color: #666563;
    margin-left: 24px;
    @include textOverflowEllipsis()
  }
  .titleMaster {
    font-weight: bold;
    @include responsive-fs(24);
    word-break: normal;
    white-space: nowrap;
  }
}
.tabsMenu {
    padding-left: 15px;
}
.itemMenu {
  font-style: normal;
  font-weight: 400;
  @include responsive-fs(12);
  text-align: center;
  color: #252422 !important;
  margin: 0 3px !important;
  &:hover {
    background: rgba(78, 102, 166, 0.08) !important;
    border-radius: 40px !important;
  }
}
.active {
  background: rgba(78, 102, 166, 0.08) !important;
  border-radius: 40px !important;
  font-weight: bold;
}
.header-line {
  position: static;
  width: 100%;
  height: 1px;
  left: 0px;
  top: 95px;
  background: #d6d6d6;
}
.menu {
  background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/SubMenu.vue